module.exports = __webpack_public_path__ + "img/16-OTJS-establish-smart-learning-goals.352e3791.svg";